import { cashText } from './cashCopy';
import { cashContent } from './cashMessages';
/** Catalog identity comes from the server marker, never a reserved name or ID. */
export function cashCategoryLabel(locale, category) {
    if (category?.direction === 'INCOME' && category.incomeSource)
        return cashText(locale, category.incomeSource === 'SALES' ? 'salesIncome' : 'manualIncome');
    return cashContent(locale, category?.name);
}
